import { LogService } from '@absg/angular-common';
import { RuleLite } from '@absg/api-station-management';
import { BaseService, EnvironmentService as SharedEnvironmentService } from '@absg/nim-client-shared';
import { Injectable } from '@angular/core';
import { EnvironmentConfig } from 'core.models/environment-config.model';
import { ElectronApplicationService } from 'shared.root/services/electron-application.service';

import { LockAccessService } from './access-point/lock-access.service';

@Injectable({ providedIn: 'root' })
export class EnvironmentService extends BaseService {

  constructor(
    loggingService: LogService,
    private lockService: LockAccessService,
    private electronApplicationService: ElectronApplicationService,
    private sharedEnvironmentService: SharedEnvironmentService,
  ) {
    super(loggingService);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadExternalConfiguration(): Promise<any> {
    const inElectron = !!this.electronApplicationService.getIpcRenderer();

    if (inElectron) {
      this.sharedEnvironmentService.setCurrentEnvironmentName(window['environment']);
      if (process.env.TERM_PROGRAM === 'vscode' && !!process.env.DEV_CONFIG_LOCATION) {
        this.sharedEnvironmentService.defaultConfigLocation = process.env.DEV_CONFIG_LOCATION;
      }
      console.log(`Loading nucleus-config.json from ${this.sharedEnvironmentService.defaultConfigLocation}`);
      return this.sharedEnvironmentService.loadExternalConfiguration();
    }
    // running from a browser so set all the things to virtual
    this.sharedEnvironmentService.setCurrentEnvironmentName(window['environment']);
    this.sharedEnvironmentService.isForcedSimulateMode = true;
    this.sharedEnvironmentService.toggleStateManagement(true);
    this.sharedEnvironmentService.setSplitReceipts(false);
    this.sharedEnvironmentService.setMaxReceiptLength(115);
    this.sharedEnvironmentService.setSendLengthToPrinter(false);
    this.sharedEnvironmentService.setUseApiPrinting(false);
  }

  setExternalConfig(rules: RuleLite[]): void {
    const config = this.sharedEnvironmentService.environmentConfig ?? new EnvironmentConfig();
    this.sharedEnvironmentService.environmentConfig = config;
    this.sharedEnvironmentService.setExternalConfig(rules, false);
    if (this.sharedEnvironmentService.environmentConfig.isSimulatorOn) {
      this.lockService.stopExpress();
    } else {
      this.lockService.startExpress();
    }
    this.lockService.setSimulateMode(this.sharedEnvironmentService.isSimulateModeOn());
  }
}
